import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import httpClient from "../Api/axios";
import signInImage from "../images/Gemini_Generated_Image_ofSiginpageCommunity.png";

const Message = ({ message, type }) => {
  if (!message) return null;
  const style = {
    padding: "0",
    margin: "10px 0",
    color: type === "success" ? "#28a745" : "#dc3545",
    fontStyle: "italic",
    textAlign: "center",
    backgroundColor: "transparent",
  };
  return <div style={style}>{message}</div>;
};

function SignInPage() {
  const [formData, setFormData] = useState({ userEmail: "", password: "" });
  const [message, setMessage] = useState({ text: "", type: "" });
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await httpClient.post("/SignIn/login", formData);

      if (response.status === 200 && response.data) {
        console.log("Login Data:", response.data); // Helpful for debugging

        const returnedEmail = response.data.userEmail || formData.userEmail;
        const returnedName = response.data.userName || "User";

        // ============================================================
        // 🚀 CRITICAL FIX: Save the User ID
        // The Notification page looks for "userId" in localStorage.
        // We check for 'signUpId' (your backend name) or 'id'.
        // ============================================================
        const userId = response.data.signUpId || response.data.id;
        localStorage.setItem("userId", userId); 

        localStorage.setItem("userEmail", returnedEmail);
        localStorage.setItem("userName", returnedName);

        setMessage({ text: "Sign In Successful!", type: "success" });

        setTimeout(() => {
          navigate("/userDashboard", { replace: true });
        }, 300);
      } else {
        setMessage({ text: "Sign In Failed! Please try again.", type: "error" });
      }
    } catch (err) {
      console.error("Error during sign-in:", err);
      if (err?.response?.data) {
        setMessage({
          text: err.response.data.message || "Invalid email or password!",
          type: "error",
        });
      } else {
        setMessage({
          text: "Sign In Failed! Check your credentials.",
          type: "error",
        });
      }
    }
  };

  return (
    <div style={styles.signinPage}>
      {/* Brand name outside card */}
      <div style={styles.brandName}>CommunityofHubs.</div>

      <div style={styles.contentContainer} className="content-container">
        <div style={styles.formCard} className="form-card">
          {/* Sign In title removed for mobile via CSS */}
          <h2 style={styles.title} className="signin-title">Sign In</h2>
          <p style={styles.subtitle} className="signin-subtitle">
            Welcome back to CommunityofHubs!
          </p>
          <Message message={message.text} type={message.type} />

          <form style={styles.form} onSubmit={handleSubmit}>
            {/* Labels removed on mobile via CSS */}
            <label style={styles.label} className="input-label"></label>
            <input
              type="email"
              name="userEmail"
              value={formData.userEmail}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter Your Email"
              required
            />

            <label style={styles.label} className="input-label"></label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter Your Password"
              required
            />

            <button
              type="submit"
              style={styles.signInBtn}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#555")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#1a1a1a")}
            >
              Sign In
            </button>
          </form>

          <p style={styles.signUpLink}>
            Don't have an account?{" "}
            <span
              onClick={() => navigate("/signup")}  // ← CHANGED TO navigate
              style={styles.linkText}
            >
              Sign Up
            </span>
          </p>

        </div>

        <div style={styles.imageContainer} className="signin-image">
          <img src={signInImage} alt="Sign in visual" style={styles.image} />
        </div>
      </div>

      <style>
        {`
          body, html, #root {
            margin: 0;
            padding: 0;
            height: 100%;
            background: #121212;
            font-family: 'Segoe UI', sans-serif;
          }

          /* Mobile view adjustments */
          @media (max-width: 768px) {
            .content-container {
              flex-direction: column;
              width: 100% !important;
              box-shadow: none !important;
              border-radius: 0 !important;
              background: transparent !important;
            }
            .form-card {
              background: transparent !important;
              width: 100% !important;
              box-shadow: none !important;
              border-radius: 0 !important;
              padding: 1.5rem !important;
              align-items: center !important;
            }
            .signin-image {
              display: none !important;
            }
            .form-card input {
              width: 90% !important;
              text-align: center !important;
            }
            .input-label,
            .signin-title {
              display: none !important;
            }
            .signin-subtitle {
              text-align: center;
            }
          }
        `}
      </style>
    </div>
  );
}

const styles = {
  signinPage: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#121212",
    padding: "1rem",
  },
  brandName: {
    fontSize: "2rem",
    fontWeight: "bold",
    fontFamily: "'Segoe UI', sans-serif",
    color: "#FFFFFF",
    marginBottom: "1.5rem",
    textAlign: "center",
  },
  contentContainer: {
    display: "flex",
    width: "min(95vw, 830px)",
    borderRadius: "15px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.8)",
    overflow: "hidden",
    backgroundColor: "#000",
  },
  formCard: {
    flex: 1,
    padding: "2rem",
    color: "white",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start", // left alignment for desktop
  },
  imageContainer: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "stretch",
    backgroundColor: "#000",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  title: {
    marginTop: "0px",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "1.5rem",
    color: "white",
    width: "100%",
  },
  subtitle: {
    textAlign: "center",
    fontSize: "1rem",
    marginBottom: "1rem",
    fontStyle: "italic",
    color: "#ccc",
    width: "100%",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    width: "100%",
    alignItems: "center",
  },
  label: {
    fontWeight: "500",
    marginBottom: "0.3rem",
    color: "white",
  },
  input: {
    padding: "0.6rem",
    border: "2px solid #FFFFFF",
    borderRadius: "8px",
    backgroundColor: "#111",
    color: "white",
    outline: "none",
    width: "100%",
  },
  signInBtn: {
    padding: "0.5rem 1.2rem",
    border: "none",
    backgroundColor: "#1a1a1a",
    color: "white",
    cursor: "pointer",
    borderRadius: "8px",
    transition: "background-color 0.3s ease",
    marginTop: "1rem",
    width: "100%",
  },
  signUpLink: {
    marginTop: "1.5rem",
    fontSize: "0.9rem",
    color: "#aaa",
    textAlign: "center",
  },
  linkText: {
    color: "#00bfff",
    cursor: "pointer",
    textDecoration: "underline",
    transition: "color 0.3s ease",
  },
};

export default SignInPage;